import {
    AUTH_SUCCESS,
    AUTH_FAIL,
    REGISTER_SUCCESS,
    SIGNOUT_SUCCESS,
    EDIT,
    DELETE_SUCCESS,
    INIT_STATE
} from '../actionTypes';


let initialState = {
    isAuth : false,
    error : '',
}


export const Reducer=(state = initialState,{type,payload})=>{
    switch (type) {
        case AUTH_SUCCESS:
            return {
                isAuth : payload,
                error : ''
            }
        case AUTH_FAIL:
            return {
             error : payload,
             isAuth: false
            }
        case SIGNOUT_SUCCESS :
        case REGISTER_SUCCESS : 
        return {
            isAuth : payload,
            error : ''
        }
        case EDIT : 
        case DELETE_SUCCESS : 
        return {
            message : payload,
            error : ''
        }
        case INIT_STATE : 
            return {
                isAuth : false,
                error : payload
            }
        default:
            return {
                ...state
            }

    }
}